import React, {useCallback} from 'react';
import {setIsRecordingMix} from 'actions/index.js';
import {connect} from 'react-redux';
import PlayButton from 'components/user/PlayButton.js';

const MixButtons = ({sequencerEngine, isRecordingMix, playingMap, setRecordingExploreMix}) => {
    let count = Object.keys(playingMap).filter(
        id => playingMap[id]).length;
    let isPlaying = count > 0;

    const onClickRecord = useCallback(() => {
        setRecordingExploreMix(!isRecordingMix);
    }, [isRecordingMix, setRecordingExploreMix]);

    const onClickPlay = useCallback((e) => {
        sequencerEngine.playMix(!isPlaying);
    }, [sequencerEngine, isPlaying]);

    return (
        <div className="work-mix-buttons">
          <PlayButton
            isPlaying={isPlaying}
            play={onClickPlay}/>
          <div
            onClick={onClickRecord}
            className={isRecordingMix ? "recording-dot" : "not-recording-dot"}>
          </div>
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        playingMap: state.sequencer.isPlaying,
        isRecordingMix: state.mix.isRecordingMix
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        setRecordingExploreMix: (x) => dispatch(setIsRecordingMix(x))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(MixButtons);

